/* NOQRO motion layer v1 – transform/opacity only, rAF-throttled, off for reduced-motion and the accessibility "no animation" switch */
(function(){
  var R = document.documentElement;
  if (!R.classList.contains('js-rv')) return;
  var mobile = window.matchMedia && matchMedia('(max-width: 749px)').matches;
  var k = mobile ? .5 : 1;

  /* thin brand progress line under the header */
  var bar = document.createElement('div');
  bar.className = 'nq-progress'; bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  /* scroll-linked drift: [selector, vertical px of travel, zoom per screen] */
  var defs = [
    ['.lh-fam-img', 38, .05],
    ['.cs-pic img', 30, .06]
  ];
  var items = [];
  defs.forEach(function(d){
    document.querySelectorAll(d[0]).forEach(function(el){ items.push({el: el, py: d[1] * k, z: d[2], on: false}); el.classList.add('nq-par'); });
  });
  var tick = false;
  function frame(){
    tick = false;
    var vh = window.innerHeight || 800;
    var h = document.documentElement.scrollHeight - vh;
    bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')';
    items.forEach(function(it){
      if (!it.on) return;
      var r = it.el.getBoundingClientRect();
      var d = ((r.top + r.height / 2) - vh / 2) / vh; /* -1 (above) .. 1 (below) */
      if (d > 1.2 || d < -1.2) return;
      var s = 1 + it.z * (1 - Math.abs(d));
      it.el.style.transform = 'translate3d(0,' + (d * it.py).toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ')';
    });
  }
  function req(){ if (!tick) { tick = true; requestAnimationFrame(frame); } }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(en){
      en.forEach(function(e){ items.forEach(function(it){ if (it.el === e.target) it.on = e.isIntersecting; }); });
      req();
    }, {rootMargin: '10% 0px'});
    items.forEach(function(it){ io.observe(it.el); });
  }
  window.addEventListener('scroll', req, {passive: true});
  window.addEventListener('resize', req, {passive: true});
  req();
})();
